var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _mask, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _mask2, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 272,
    viewBox: "0 0 272 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.566 199.784H84.3807C83.5782 199.784 83.3266 198.7 84.0471 198.346C88.0905 196.363 90.6531 192.252 90.6531 187.749V163.625H98.6108V187.436C98.6108 192.1 101.358 196.327 105.62 198.222L105.873 198.334C106.621 198.667 106.384 199.784 105.566 199.784Z",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.921 155.697H78.0252C75.8361 155.697 74.0615 157.472 74.0615 159.661C74.0615 161.85 75.8361 163.625 78.0252 163.625H111.921C114.11 163.625 115.885 161.85 115.885 159.661C115.885 157.472 114.11 155.697 111.921 155.697Z",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8659 168.166C93.4476 167.022 96.0293 165.878 98.611 164.734V163.853C95.9585 163.777 93.3059 163.701 90.6533 163.625C90.7242 165.139 90.7951 166.652 90.8659 168.166Z",
    fill: "#152028",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.801 137.82L136.801 137.82C136.682 137.772 136.554 137.724 136.427 137.678H206.956C208.932 137.678 210.564 136.206 210.818 134.299C210.921 134.652 210.977 135.029 210.977 135.421C210.977 137.485 209.436 139.122 207.578 139.122H138.852C138.236 138.624 137.574 138.131 136.801 137.82Z",
    fill: "#152028",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.928 130.133L206.955 130.132C208.743 130.132 210.232 131.419 210.542 133.116C210.582 133.33 210.602 133.552 210.602 133.779C210.602 135.794 208.97 137.428 206.955 137.428L135.226 137.428",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.885 114.197L139.855 119.167",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.821 126.598L135.378 130.133H177.019L187.589 104.248C187.719 103.928 187.484 103.578 187.138 103.578H159.26",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.647 103.772L187.65 103.766C187.956 103.846 188.296 104.029 188.517 104.452C188.843 105.074 188.712 105.683 188.666 105.86L178.865 129.883H176.855L187.647 103.772Z",
    fill: "#152028",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.672 119.862H150.324L149.714 121.631H148.093C147.895 121.631 147.764 121.424 147.848 121.245L148.427 120.018C148.472 119.923 148.567 119.862 148.672 119.862Z",
    fill: "#152028"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171.773 123.208H174.324C174.696 123.208 174.885 122.94 175.083 122.525L177.278 118.131C177.431 117.531 177.02 117.419 176.668 117.28L172.407 116.017C172.058 115.878 171.442 115.848 171.731 115.202L174.221 108.635C174.479 107.696 173.639 107.696 173.082 107.696H157.463",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.613 123.208H166.529",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.453 114.197L149.396 122.491C149.142 123.206 149.602 123.208 150.229 123.208H151.556",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.13 122.971L156.13 122.971L156.13 122.973C156.139 123.048 156.143 123.127 156.143 123.207C156.143 124.38 155.192 125.331 154.019 125.331C152.845 125.331 151.895 124.38 151.895 123.207C151.895 122.234 152.549 121.413 153.442 121.161L153.443 121.161C153.625 121.11 153.818 121.082 154.019 121.082C155.113 121.082 156.013 121.908 156.13 122.971ZM152.898 123.206C152.898 123.825 153.4 124.328 154.019 124.328C154.638 124.328 155.14 123.825 155.14 123.206C155.14 122.587 154.638 122.085 154.019 122.085C153.4 122.085 152.898 122.587 152.898 123.206Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.188 122.971L171.188 122.971C171.071 121.908 170.171 121.082 169.077 121.082C168.848 121.082 168.627 121.119 168.421 121.186L171.188 122.971ZM171.188 122.971L171.188 122.973M171.188 122.971L171.188 122.973M171.188 122.973C171.197 123.048 171.202 123.127 171.202 123.207C171.202 124.38 170.251 125.331 169.077 125.331C167.904 125.331 166.952 124.38 166.952 123.207C166.952 122.263 167.568 121.462 168.42 121.186L171.188 122.973ZM167.956 123.206C167.956 123.825 168.458 124.328 169.077 124.328C169.696 124.328 170.198 123.825 170.198 123.206C170.198 122.587 169.696 122.085 169.077 122.085C168.458 122.085 167.956 122.587 167.956 123.206Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.713 118.79L176.208 119.932C175.924 119.839 175.745 119.554 175.792 119.253L175.544 119.215L175.792 119.253C175.846 118.904 176.182 118.673 176.527 118.746L176.713 118.79Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.144 114.681L170.058 114.911C169.991 114.894 169.921 114.884 169.849 114.884H168.678C168.455 114.884 168.246 114.971 168.088 115.129L168.088 115.129C167.986 115.231 167.915 115.356 167.876 115.493C167.858 115.555 167.85 115.616 167.847 115.671L167.616 115.668L167.616 115.668L165.13 115.632L165.13 115.632H165.127C164.989 115.632 164.871 115.61 164.808 115.572C164.784 115.557 164.78 115.546 164.778 115.542C164.776 115.536 164.768 115.507 164.787 115.438L166.93 109.701L166.93 109.701L166.932 109.696C167.043 109.379 167.296 109.227 167.525 109.227H171.781C171.93 109.227 172.028 109.244 172.078 109.275C172.095 109.285 172.102 109.295 172.108 109.31C172.114 109.327 172.123 109.365 172.114 109.438L170.144 114.681L170.144 114.681Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.422 109.42C156.209 109.974 154.671 113.749 154.212 113.871L153.807 114.794L157.965 111.454L156.422 109.42Z",
    fill: "#152028"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M164.769 108.992L159.271 112.344L156.723 108.981H164.585C164.646 108.981 164.709 108.984 164.769 108.992Z",
    fill: "#0E171E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.917 115.675L158.226 112.211L158.808 112.979L158.808 112.979L158.809 112.98C158.906 113.106 159.052 113.178 159.209 113.178C159.3 113.178 159.391 113.153 159.471 113.104L160.789 112.299L162.17 115.649L154.109 115.691C154.109 115.691 154.108 115.691 154.108 115.691C154.041 115.691 153.975 115.686 153.917 115.675Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.165 109.332C165.17 109.382 165.17 109.44 165.163 109.506L163.017 115.261C162.982 115.351 162.949 115.429 162.921 115.495L161.345 111.669L165.125 109.365C165.14 109.355 165.153 109.345 165.165 109.332Z",
    fill: "#152028"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M167.844 115.943C167.844 116.404 168.217 116.777 168.678 116.777H169.959C170.189 116.777 170.397 116.684 170.549 116.533C170.7 116.382 170.794 116.173 170.794 115.943C170.794 115.836 170.774 115.734 170.736 115.64C170.744 115.685 170.748 115.731 170.748 115.778C170.748 116.008 170.654 116.218 170.503 116.368C170.352 116.519 170.144 116.613 169.913 116.613H168.743C168.282 116.613 167.909 116.239 167.909 115.778C167.909 115.701 167.919 115.627 167.938 115.557C167.878 115.672 167.844 115.804 167.844 115.943Z",
    fill: "#0E171E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.92 115.538C170.864 115.2 170.658 114.923 170.378 114.769C170.222 114.681 170.041 114.631 169.849 114.631H168.678C168.389 114.631 168.117 114.744 167.91 114.948C167.777 115.082 167.681 115.248 167.631 115.429C167.605 115.525 167.593 115.621 167.593 115.716C167.593 115.784 167.6 115.852 167.613 115.918C167.706 116.421 168.147 116.804 168.678 116.804H169.849C170.139 116.804 170.411 116.691 170.615 116.487C170.822 116.281 170.935 116.009 170.935 115.716C170.935 115.656 170.93 115.595 170.92 115.538ZM170.26 116.129C170.149 116.24 170.003 116.301 169.849 116.301H168.678C168.429 116.301 168.22 116.145 168.134 115.925C168.109 115.86 168.096 115.789 168.096 115.716C168.096 115.666 168.102 115.613 168.117 115.563C168.144 115.465 168.195 115.376 168.265 115.306C168.376 115.195 168.522 115.135 168.678 115.135H169.849C169.978 115.135 170.099 115.177 170.197 115.253C170.313 115.336 170.398 115.467 170.424 115.623C170.429 115.653 170.431 115.686 170.431 115.716C170.431 115.873 170.371 116.019 170.26 116.129Z",
    fill: "#152028"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.456 118.25H165.983C166.107 118.25 166.208 118.149 166.208 118.025V118.022C166.208 117.898 166.107 117.797 165.983 117.797H164.456C164.332 117.797 164.231 117.898 164.231 118.022V118.025C164.231 118.149 164.332 118.25 164.456 118.25Z",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-1_8126_138875",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.469 118.691H164.97C164.72 118.691 164.517 118.489 164.517 118.239H165.922C165.922 118.489 165.719 118.691 165.469 118.691Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.469 118.691H164.97C164.72 118.691 164.517 118.489 164.517 118.239H165.922C165.922 118.489 165.719 118.691 165.469 118.691Z",
    fill: "#0E171E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.517 118.239V117.739H164.017V118.239H164.517ZM165.922 118.239H166.422V117.739H165.922V118.239ZM165.469 118.191H164.97V119.191H165.469V118.191ZM164.97 118.191C164.996 118.191 165.017 118.212 165.017 118.239H164.017C164.017 118.765 164.444 119.191 164.97 119.191V118.191ZM164.517 118.739H165.922V117.739H164.517V118.739ZM165.422 118.239C165.422 118.212 165.443 118.191 165.469 118.191V119.191C165.995 119.191 166.422 118.765 166.422 118.239H165.422Z",
    fill: "#152028",
    mask: "url(#path-24-inside-1_8126_138875)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.548 122.127H146.396H147.548Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M147.548 122.127H146.396",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 122.636H145.68H146.162Z",
    fill: "#152028"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 122.636H145.68",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M139.793 105.901L136.505 112.911C136.265 113.446 136.657 114.051 137.243 114.051H154.04C154.359 114.051 154.648 113.864 154.778 113.573L162.013 97.4338C162.253 96.8986 161.862 96.2939 161.275 96.2939H147.021",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M142.592 105.902C143.346 106.806 144.1 107.709 144.853 108.613C147.86 108.643 150.867 108.673 153.874 108.704C154.892 107.732 155.909 106.76 156.927 105.788V101.255H153.1C151.93 102.379 150.761 103.502 149.592 104.626H143.317",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M143.553 107.054C147.61 107.015 151.668 106.975 155.725 106.936L153.874 108.704L144.853 108.613L143.553 107.054Z",
    fill: "#152028"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.257 105.469C151.985 105.298 151.822 105.006 151.847 104.718C151.883 104.321 152.272 103.976 152.759 103.989",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M154.353 105.378C154.032 105.156 153.923 104.743 154.079 104.422C154.211 104.151 154.511 103.985 154.831 104.012",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M143.378 104.626H148.98L148.999 102.097C148.999 102.097 146.039 102.049 144.559 102.024",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.152 104.626C146.167 103.768 146.182 102.91 146.197 102.052",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M145.188 100.294L147.633 100.298L147.643 102.006",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M141.915 109.752C142.19 110.042 142.622 110.114 142.963 109.934C143.272 109.77 143.454 109.427 143.419 109.068C143.582 109.759 144.202 110.214 144.831 110.162C145.328 110.12 145.77 109.767 145.958 109.263C146.144 109.973 146.833 110.402 147.473 110.276C148.004 110.171 148.428 109.701 148.498 109.114C148.631 109.7 149.155 110.109 149.728 110.093C150.247 110.079 150.711 109.721 150.867 109.205C150.913 109.299 151.153 109.766 151.71 109.957C152.146 110.105 152.52 109.998 152.644 109.957",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M149.384 88.1445H132.588C132.269 88.1445 131.98 88.3317 131.85 88.6225L124.615 104.762C124.375 105.297 124.766 105.901 125.353 105.901H142.149C142.468 105.901 142.757 105.714 142.887 105.423L150.123 89.2843C150.363 88.7491 149.971 88.1445 149.384 88.1445Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.742 98.2248L130.767 98.5923L129.539 95.9869C129.539 95.9869 129.37 95.6837 129.526 95.3678C129.662 95.0917 129.989 94.956 130.287 95.035C130.655 95.1329 131.217 95.5005 131.905 96.6458L134.69 95.9869L142.566 93.681C142.566 93.681 144.309 93.0103 145.766 94.4111C145.989 94.6256 145.979 94.9893 145.749 95.1966C145.379 95.53 144.548 96.0275 142.715 96.7056L139.796 97.6018",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.097 97.2765L134.824 101.491C134.676 101.981 135.2 102.408 135.646 102.157C136.762 101.531 138.591 99.9656 140.679 96.0557",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 95.9862L133.634 94.8905C133.455 94.7039 133.596 94.3938 133.855 94.4077L139.119 94.6893",
    fill: "#152028"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 95.9862L133.634 94.8905C133.455 94.7039 133.596 94.3938 133.855 94.4077L139.119 94.6893",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.184 96.6533H134.914V97.1362H135.184V96.6533Z",
    fill: "#0E171E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M136.591 96.3613H136.321V96.8442H136.591V96.3613Z",
    fill: "#0E171E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.254 95.5039H138.984V95.9868H139.254V95.5039Z",
    fill: "#0E171E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M137.963 95.9863H137.693V96.4692H137.963V95.9863Z",
    fill: "#152028"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M140.813 95.0615H140.544V95.5444H140.813V95.0615Z",
    fill: "#0E171E"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-2_8126_138875",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.064 94.8203H141.795V95.3032H142.064V94.8203Z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M142.064 94.8203H141.795V95.3032H142.064V94.8203Z",
    fill: "#0E171E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M141.795 94.8203V94.3203H141.295V94.8203H141.795ZM142.064 94.8203H142.564V94.3203H142.064V94.8203ZM142.064 95.3032V95.8032H142.564V95.3032H142.064ZM141.795 95.3032H141.295V95.8032H141.795V95.3032ZM141.795 95.3203H142.064V94.3203H141.795V95.3203ZM141.564 94.8203V95.3032H142.564V94.8203H141.564ZM142.064 94.8032H141.795V95.8032H142.064V94.8032ZM142.295 95.3032V94.8203H141.295V95.3032H142.295Z",
    fill: "#152028",
    mask: "url(#path-49-inside-2_8126_138875)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M145.22 94.2514C145.221 94.252 145.222 94.2527 145.222 94.2534C145.074 94.5151 144.861 94.6103 144.671 94.6447C144.556 94.6657 144.447 94.6635 144.366 94.6555C144.326 94.6515 144.294 94.6463 144.273 94.6422C144.264 94.6405 144.257 94.6391 144.253 94.638C144.001 94.5526 143.852 94.4427 143.763 94.3392C143.674 94.2349 143.633 94.1237 143.618 94.0183C143.604 93.918 143.613 93.8226 143.628 93.7474C144.155 93.6978 144.569 93.8389 144.858 93.9988C145.018 94.0868 145.139 94.1806 145.22 94.2514Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M178.659 126.494H136.775",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M200.991 129.882H188.457L189.498 128.329L189.498 128.329C190.038 127.522 190.948 127.037 191.92 127.037H197.617C198.63 127.037 199.572 127.564 200.101 128.429L200.101 128.429L200.991 129.882Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M194.772 126.787C197.435 120.069 199.163 115.416 201.826 108.697",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M200.544 103.773C194.621 97.8348 190.231 93.434 184.309 87.4961",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M202.806 108.863C204.442 108.863 205.767 107.537 205.767 105.902C205.767 104.266 204.442 102.94 202.806 102.94C201.171 102.94 199.845 104.266 199.845 105.902C199.845 107.537 201.171 108.863 202.806 108.863Z",
    fill: "#152028",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M185.788 82.6864C183.948 81.3633 181.384 81.7821 180.061 83.6218L178.186 86.5979L179.157 87.3411C179.356 87.2619 179.589 87.2542 179.829 87.3628C180.74 87.7741 181.675 88.2662 182.47 88.877C183.112 89.371 183.457 90.0809 183.941 90.7113C184.049 90.8516 184.095 90.9906 184.1 91.1223L184.309 91.2818L186.723 88.4132C188.046 86.5735 187.628 84.0094 185.788 82.6864Z",
    fill: "#152028"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M180.779 87.9853L182.357 89.1204C185.438 91.3355 186.14 95.6346 183.925 98.7148L182.867 100.186L170.127 91.0235L171.185 89.5525C173.4 86.4724 177.699 85.7701 180.779 87.9853Z",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M131.621 201.409C140.786 201.482 149.6 201.482 158.667 200.726C166.474 199.719 174.282 199.215 181.334 194.43C181.837 194.178 182.593 194.178 183.097 193.674C185.363 192.415 187.882 192.919 189.775 194.469",
    fill: "#152028"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M131.621 201.409C140.786 201.482 149.6 201.482 158.667 200.726C166.474 199.719 174.282 199.215 181.334 194.43C181.837 194.178 182.593 194.178 183.097 193.674C185.363 192.415 187.882 192.919 189.775 194.469",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M70.25 199.435C71.7784 200.222 73.0377 199.467 74.297 198.711C74.8007 198.459 75.0525 197.956 74.8007 197.2C74.5488 196.948 74.0451 196.696 73.5414 197.2C72.7858 198.207 73.2895 199.467 74.297 199.97C76.8155 200.978 79.334 201.23 82.1044 200.978C86.134 200.222 90.1636 199.97 94.1933 199.719C103.008 199.215 110.903 200.157 119.722 200.772",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2313 199.365C57.9417 199.229 57.7704 199.101 57.652 199.008C57.3725 198.786 56.7378 198.277 56.2719 197.383C55.6976 196.29 55.7153 195.268 55.7228 194.802C55.743 193.716 56.1409 192.356 56.9191 191.08C56.9645 191.107 57.0249 191.122 57.0879 191.115C57.3574 191.08 57.6269 191.052 57.8963 191.034C57.4833 191.636 57.1786 192.286 56.9846 192.971C56.1888 195.789 57.5236 198.3 58.2313 199.365Z",
    fill: "#0E171E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0998 199.905C59.6062 199.819 59.2133 199.721 58.896 199.623C58.9237 199.547 58.9136 199.461 58.8633 199.393C58.3243 198.663 56.6369 196.054 57.4705 193.11C57.6821 192.357 58.0397 191.651 58.5409 191.004C58.8406 190.994 59.1378 190.997 59.435 191.009C59.2183 191.415 59.0395 191.835 58.9011 192.266C57.9062 195.369 59.1705 198.318 60.0998 199.905Z",
    fill: "#0E171E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3011 200.154C61.6765 200.114 61.135 200.058 60.6691 199.993C60.6791 199.937 60.6691 199.88 60.6388 199.827C59.7498 198.363 58.4049 195.457 59.3796 192.42C59.5332 191.944 59.7397 191.48 59.9941 191.042C60.3718 191.072 60.7471 191.118 61.1224 191.178C60.722 191.714 60.4071 192.296 60.1905 192.901C60.1779 192.923 60.1678 192.951 60.1628 192.976C60.0469 193.306 59.9614 193.639 59.9085 193.979V193.981C59.9034 193.999 59.9009 194.016 59.8984 194.037V194.052C59.8883 194.092 59.8833 194.135 59.8782 194.178C59.4904 197.202 61.538 199.439 62.3011 200.154Z",
    fill: "#0E171E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7093 191.529C62.4323 191.765 62.1351 191.974 61.8228 192.156C61.513 192.337 61.1881 192.491 60.8506 192.614C61.105 192.06 61.4123 191.612 61.6817 191.279H61.6842C62.0293 191.35 62.3718 191.433 62.7093 191.529Z",
    fill: "#152028"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6108 193.223C61.122 193.072 61.6157 192.86 62.0766 192.591C62.5072 192.339 62.9102 192.042 63.2729 191.704C63.6456 191.825 64.0032 191.961 64.3432 192.107C63.9328 192.555 63.3082 193.079 62.4342 193.429C61.8096 193.681 61.1296 193.81 60.4521 193.807C60.4949 193.603 60.5478 193.409 60.6108 193.223Z",
    fill: "#0E171E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6768 188.269C61.3541 187.229 63.2732 186.922 65.1017 187.101C64.7289 187.282 64.3738 187.501 64.0464 187.755C63.7744 187.967 63.52 188.206 63.2883 188.468C62.0996 188.282 60.8907 188.214 59.6768 188.269Z",
    fill: "#0E171E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6211 193.898C63.6612 193.48 64.379 192.84 64.8272 192.326C65.2756 192.535 65.6937 192.764 66.0815 193.004C65.3385 193.465 64.2555 193.963 62.8956 194.112C62.538 194.15 62.1828 194.162 61.8252 194.15C62.0972 194.087 62.3642 194.001 62.6211 193.898Z",
    fill: "#152028"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4262 198.363C66.0585 198.937 65.7109 199.522 65.3835 200.114C65.3609 200.154 65.3508 200.197 65.3508 200.237C65.2803 200.24 65.2097 200.24 65.1393 200.24C64.3282 200.24 63.6055 200.224 62.9607 200.192C62.9632 200.116 62.9305 200.041 62.8676 199.988C62.7819 199.917 62.5074 199.678 62.1699 199.3C62.855 199.25 63.5375 199.154 64.2048 199.013C64.9579 198.852 65.7033 198.635 66.4262 198.363Z",
    fill: "#0E171E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5104 188.35C64.8934 188.051 65.3198 187.809 65.7782 187.629C65.864 187.596 65.9336 187.544 65.986 187.48C66.1124 187.504 66.2383 187.53 66.3635 187.558C66.2416 187.641 66.1223 187.727 66.0058 187.816C65.6921 188.053 65.3947 188.315 65.119 188.599C64.8851 188.537 64.6501 188.48 64.4142 188.428C64.4461 188.401 64.4781 188.375 64.5104 188.35Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3544 194.467C60.9286 194.596 61.5129 194.659 62.0947 194.659C62.3792 194.659 62.6664 194.644 62.9484 194.614C64.2228 194.475 65.4644 194.022 66.5524 193.299C66.9478 193.561 67.308 193.828 67.6329 194.09C66.6658 195.12 65.4745 195.941 64.18 196.467C63.1071 196.903 61.9713 197.142 60.8026 197.177C60.4727 196.397 60.2662 195.482 60.3544 194.467Z",
    fill: "#152028"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6126 188.614L66.6126 188.614L66.6132 188.614C66.9121 188.386 67.2307 188.181 67.5618 188.003L67.5618 188.003L67.5626 188.003C67.5969 187.984 67.6281 187.962 67.6561 187.938C67.7882 187.986 67.9188 188.036 68.0476 188.089C67.8809 188.221 67.722 188.362 67.5724 188.51L67.5724 188.51L67.5715 188.511C67.3591 188.723 67.1614 188.952 66.9848 189.198C66.7351 189.102 66.4827 189.013 66.2286 188.929C66.3529 188.819 66.481 188.714 66.6126 188.614Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8913 198.565C61.7394 198.361 61.5868 198.136 61.4426 197.891C62.4826 197.802 63.496 197.559 64.4626 197.167L64.4628 197.167C65.7928 196.627 67.0199 195.8 68.0335 194.763C68.1762 194.89 68.3104 195.016 68.4359 195.139C68.2259 195.396 68.0221 195.655 67.8219 195.917L67.8211 195.918C67.4508 196.408 67.0892 196.908 66.7432 197.423C65.8748 197.795 64.9694 198.082 64.0479 198.275L64.0479 198.275L64.0468 198.275C63.34 198.427 62.6153 198.523 61.8913 198.565Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1254 191.206C66.067 191.769 67.9265 192.602 69.6757 193.695C69.4732 193.916 69.2747 194.141 69.0801 194.368C68.5038 193.809 67.7644 193.188 66.8614 192.602C66.835 192.582 66.8091 192.567 66.795 192.559C66.2535 192.211 65.6538 191.876 64.9936 191.573C64.9708 191.56 64.9502 191.552 64.9409 191.548C64.6791 191.429 64.407 191.314 64.1254 191.206Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2794 189.223L68.2794 189.223L68.2805 189.222C68.5045 188.998 68.7522 188.798 69.0187 188.626C69.0413 188.612 69.0624 188.596 69.0819 188.579C69.4561 188.782 69.8066 189.005 70.1273 189.242C69.9211 189.375 69.7278 189.528 69.5505 189.698C69.3965 189.844 69.2555 190.003 69.1296 190.172C68.7417 189.965 68.3465 189.772 67.945 189.593C68.0499 189.463 68.1616 189.339 68.2794 189.223Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6005 190.052C61.1145 189.748 59.5883 189.589 58.0596 189.589C58.3643 189.269 58.6968 188.967 59.0594 188.692C59.1098 188.761 59.1904 188.803 59.281 188.796C60.6461 188.702 62.0061 188.768 63.3409 188.99C64.0486 189.105 64.7462 189.267 65.4388 189.471C67.2597 190.01 68.9648 190.828 70.5136 191.909C70.5162 191.914 70.5187 191.916 70.5237 191.919C70.5288 191.921 70.5313 191.924 70.5363 191.926C70.773 192.09 71.0047 192.261 71.234 192.44C70.9544 192.709 70.6799 192.989 70.4129 193.271C67.9976 191.705 65.3683 190.622 62.6005 190.052Z",
    fill: "#152028"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2417 190.426L70.2417 190.426L70.2444 190.423C70.4487 190.226 70.683 190.06 70.9385 189.931C71.0803 190.07 71.2114 190.212 71.3309 190.356C71.17 190.458 71.0171 190.572 70.8744 190.699L70.8741 190.699C70.7604 190.801 70.6523 190.909 70.5514 191.024C70.3719 190.904 70.1904 190.789 70.0075 190.677C70.0804 190.588 70.1586 190.504 70.2417 190.426Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3814 191.603C71.4314 191.55 71.4839 191.5 71.5385 191.451C71.6514 191.353 71.7714 191.264 71.8976 191.186C71.9336 191.252 71.9668 191.315 71.9971 191.376C71.9935 191.379 71.9899 191.382 71.9863 191.386L71.9862 191.386C71.852 191.507 71.7172 191.631 71.584 191.756C71.5169 191.704 71.4494 191.653 71.3814 191.603Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3029 196.26L69.3026 196.261C68.4394 197.402 67.6932 198.639 67.0891 199.938C66.8546 199.953 66.6025 199.965 66.3303 199.973C67.0191 198.779 67.7914 197.622 68.6231 196.528C69.7527 195.044 71.0165 193.651 72.3854 192.38C72.4352 192.564 72.474 192.745 72.5024 192.925C72.4965 192.929 72.4906 192.934 72.4847 192.939L72.4847 192.939L72.4829 192.94C71.2996 193.922 70.2312 195.039 69.3029 196.26Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6866 198.016C71.0588 197.55 71.4714 197.123 71.9216 196.738C71.662 197.319 71.4172 197.686 71.3833 197.736C71.1362 198.092 70.7998 198.575 70.2039 199.028C70.0857 199.118 69.9666 199.2 69.8425 199.274C70.0898 198.833 70.3724 198.411 70.6866 198.016Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5045 199.711L68.5044 199.711L68.5021 199.717C68.4948 199.735 68.4883 199.753 68.4829 199.772C68.4132 199.786 68.3414 199.799 68.2672 199.811C68.7864 198.778 69.4025 197.79 70.1036 196.867L70.1038 196.867C70.8353 195.903 71.6624 195.006 72.5654 194.197C72.547 194.52 72.5032 194.831 72.4431 195.126C72.397 195.14 72.3521 195.16 72.3103 195.188C71.3946 195.794 70.5844 196.535 69.9031 197.391C69.3377 198.099 68.8681 198.881 68.5045 199.711Z",
    fill: "#0E171E",
    stroke: "#152028",
    strokeWidth: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M211.26 190.747C211.025 189.445 210.59 188.158 209.973 186.904C210.814 185.536 211.635 183.683 211.781 181.439C211.967 178.578 210.995 176.127 210.534 174.968C209.094 171.339 206.918 169.236 207.467 166.982C207.532 166.715 207.716 165.96 208.348 165.584C209.114 165.129 210.091 165.499 210.474 165.645C212.393 166.37 215.148 170.118 216.002 174.56C217.392 181.804 213.212 188.186 211.26 190.747Z",
    stroke: "#152028",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M184.136 166.519C184.199 164.889 184.337 163.285 184.665 163.265C184.702 163.262 184.733 163.287 184.753 163.305C185.418 163.907 185.949 165.834 186.972 166.466C187.171 166.589 187.488 166.723 187.976 166.723C188.037 166.083 188.201 165.592 188.342 165.265C188.442 165.03 188.913 163.927 189.362 163.985C189.44 163.995 189.493 164.035 189.525 164.066C190.369 164.783 190.752 167.428 190.752 167.43C190.996 169.138 191.12 169.992 191.344 170.649C191.742 171.818 192.344 172.664 192.767 173.178C200.957 176.399 207.243 181.353 209.973 186.904",
    fill: "#152028"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M184.136 166.519C184.199 164.889 184.337 163.285 184.665 163.265C184.702 163.262 184.733 163.287 184.753 163.305C185.418 163.907 185.949 165.834 186.972 166.466C187.171 166.589 187.488 166.723 187.976 166.723C188.037 166.083 188.201 165.592 188.342 165.265C188.442 165.03 188.913 163.927 189.362 163.985C189.44 163.995 189.493 164.035 189.525 164.066C190.369 164.783 190.752 167.428 190.752 167.43C190.996 169.138 191.12 169.992 191.344 170.649C191.742 171.818 192.344 172.664 192.767 173.178C200.957 176.399 207.243 181.353 209.973 186.904",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M211.26 190.747C211.385 191.447 211.453 192.155 211.461 192.863C211.474 194.243 211.257 195.867 210.564 197.688",
    fill: "#152028"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M211.26 190.747C211.385 191.447 211.453 192.155 211.461 192.863C211.474 194.243 211.257 195.867 210.564 197.688",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M184.136 166.519C183.521 166.583 181.968 166.83 180.584 168.055C180.063 168.516 178.602 169.809 178.682 171.438C178.742 172.678 179.638 172.952 180.765 175.268C180.765 175.268 181.164 176.09 181.695 177.723C182.48 180.134 183.195 187.091 183.056 196.427",
    fill: "#152028"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M184.136 166.519C183.521 166.583 181.968 166.83 180.584 168.055C180.063 168.516 178.602 169.809 178.682 171.438C178.742 172.678 179.638 172.952 180.765 175.268C180.765 175.268 181.164 176.09 181.695 177.723C182.48 180.134 183.195 187.091 183.056 196.427",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M188.477 181.233C188.228 183.062 187.968 184.621 187.748 185.835C187.494 187.236 186.531 192.382 184.842 194.184C184.691 194.345 184.532 194.522 184.217 194.878C183.169 196.062 183.01 196.335 182.919 196.655C182.839 196.936 182.686 197.471 182.937 197.892C183.12 198.197 183.537 198.477 185.948 198.5C186.634 198.507 187.568 198.494 188.682 198.409",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M197.771 183.898C197.048 184.138 195.063 184.902 193.648 186.951C191.563 189.969 192.418 193.309 192.555 193.808C192.447 193.816 192.241 193.836 191.988 193.882C189.876 194.274 187.955 195.927 187.885 197.338C187.867 197.688 187.971 197.876 188.021 197.954C188.349 198.455 189.164 198.46 189.548 198.455C190.823 198.438 198.983 198.126 210.565 197.688",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M186.165 171.438C186.653 171.549 187.184 171.693 187.748 171.883C188.315 172.073 188.828 172.28 189.286 172.486",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M186.177 172.543C186.51 172.635 186.984 172.805 187.487 173.135C188.009 173.478 188.362 173.861 188.58 174.138",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M183.203 169.707C183.084 170.097 183.268 170.516 183.625 170.687C184.002 170.866 184.47 170.72 184.684 170.345",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M182.007 169.889C181.934 170.059 181.962 170.217 182.03 170.253C182.102 170.291 182.267 170.217 182.36 170.025",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M180.22 169.365C180.39 169.618 180.685 169.752 180.971 169.706C181.314 169.652 181.585 169.35 181.609 168.978",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M145.616 183.813L153.647 197.781C159.091 194.518 164.536 191.255 169.98 187.991C170.687 187.568 170.499 186.495 169.69 186.338L165.121 185.45C164.719 185.372 164.368 185.129 164.154 184.78L157.968 174.834L145.616 183.813Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M147.501 186.585C151.944 183.938 156.056 181.487 160.499 178.84",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M148.848 189.307C149.641 189.25 152.255 189.164 154.77 190.917C156.74 192.289 157.625 194.075 157.96 194.865",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M169.137 183.748C168.812 184.069 168.342 184.465 167.71 184.811C166.857 185.277 166.065 185.456 165.537 185.531",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M165.264 185.176C164.424 183.863 164.353 182.476 165.005 181.776C165.14 181.63 165.387 181.428 165.826 181.319C166.192 181.271 166.615 181.391 166.874 181.683C167.279 182.14 167.113 182.813 167.026 183.156C166.72 184.366 165.609 184.997 165.264 185.176Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M145.616 183.813C149.734 180.82 153.851 177.827 157.968 174.834C158.416 175.598 158.864 176.363 159.312 177.127C155.004 179.78 150.696 182.432 146.388 185.085C146.131 184.661 145.873 184.237 145.616 183.813Z",
    fill: "#0E171E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M114.06 184.387L111.705 199.672C117.986 200.59 124.266 201.508 130.547 202.426C131.363 202.545 131.895 201.595 131.368 200.962L128.392 197.383C128.13 197.068 128.012 196.658 128.067 196.253L129.591 184.902L114.06 184.387Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M113.648 187.058C118.764 187.818 123.879 188.579 128.995 189.34",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M113.351 190.073C114.001 190.532 116.079 192.119 116.919 195.067C117.576 197.376 117.131 199.319 116.89 200.143",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M132.579 198.606C132.124 198.649 131.509 198.659 130.801 198.526C129.846 198.347 129.12 197.985 128.663 197.709",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M128.677 197.262C128.857 195.714 129.679 194.595 130.627 194.465C130.824 194.438 131.143 194.437 131.553 194.631C131.866 194.825 132.117 195.186 132.133 195.576C132.158 196.186 131.603 196.602 131.319 196.813C130.316 197.556 129.057 197.342 128.677 197.262Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M114.237 184.387C119.319 184.674 124.509 184.615 129.591 184.902C129.454 185.778 129.296 186.387 129.159 187.262C124.145 186.591 119.131 185.919 114.116 185.248C114.185 184.757 114.168 184.878 114.237 184.387Z",
    fill: "#0E171E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3108 136.527L69.8604 142.253C69.2531 149.972 75.4693 156.515 83.2092 156.304L119.224 155.323L113.008 184.355L131.536 184.902L134.512 163.944L144.535 184.598L159.661 173.603L142.385 143.579C139.882 139.229 135.246 136.548 130.228 136.548H100.92L70.3108 136.527Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M120.662 136.537C122.073 136.532 123.484 136.527 124.895 136.523C131.951 136.499 137.399 142.717 136.448 149.708L134.512 163.945",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M134.512 163.945C135.211 158.468 135.911 152.991 136.61 147.514C136.728 147.602 137.049 162.101 137.092 169.261C136.232 167.489 135.372 165.717 134.512 163.945Z",
    fill: "#0E171E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3154 87.5131L95.0272 81.3907C95.0272 81.3907 96.01 77.9476 98.4593 76.0451C102.13 73.1941 106.482 74.2316 107.04 74.3746C107.672 74.4252 108.938 73.0078 108.938 73.0078C108.938 73.0078 108.885 75.9854 108.859 76.7148C108.828 77.2949 108.894 78.0324 109.35 78.6447C109.678 79.0857 110.042 79.2384 110.031 79.538C110.022 79.801 109.726 80.1511 108.482 80.5403C108.488 81.3174 108.493 82.0944 108.498 82.8715C108.506 84.1085 107.525 85.1259 106.289 85.1631C104.671 85.2117 101.436 85.3089 101.436 85.3089L100.033 88.1449",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7227 79.5685C87.9257 78.6875 89.5816 78.7187 91.7319 77.5335C93.1647 76.7438 93.9252 75.9055 94.3972 75.4909C95.8807 74.1875 99.505 72.7496 108.573 72.165C109.106 73.3124 108.901 74.6467 108.156 75.6048C107.308 76.6953 105.439 76.819 104.238 76.5843C103.275 76.3961 102.613 75.9348 101.991 76.3055C101.508 76.5931 101.373 77.1877 101.35 77.3001C101.171 78.1756 101.83 78.6734 101.96 79.4318C102.194 80.7994 100.558 82.1547 100.16 82.4843C97.0971 85.0223 91.6485 83.8054 88.8389 81.3681C88.3959 80.9838 87.5653 80.2512 87.7227 79.5685Z",
    fill: "#0E171E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8447 75.7413C95.4764 72.7696 97.7654 70.4278 100.692 69.7578C103.462 69.1234 106.381 70.0848 108.27 72.2484C103.795 73.4127 99.3197 74.577 94.8447 75.7413Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M108.27 72.2482C110.107 71.7419 111.945 71.2357 113.782 70.7295C113.732 70.938 113.386 72.289 112.097 72.9315C110.89 73.5325 109.352 73.2681 108.27 72.2482Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M102.833 77.5635C102.949 77.6728 103.114 77.8079 103.334 77.928C103.56 78.0514 103.769 78.1181 103.926 78.1558",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M102.833 77.5635C102.949 77.6728 103.114 77.8079 103.334 77.928C103.56 78.0514 103.769 78.1181 103.926 78.1558",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M106.068 80.373C106.123 80.4671 106.273 80.6969 106.57 80.8438C106.821 80.9686 107.052 80.9712 107.162 80.9653",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M106.068 80.373C106.123 80.4671 106.273 80.6969 106.57 80.8438C106.821 80.9686 107.052 80.9712 107.162 80.9653",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M106.915 79.5175C107.819 79.5175 108.553 78.7843 108.553 77.8798C108.553 76.9754 107.819 76.2422 106.915 76.2422C106.011 76.2422 105.277 76.9754 105.277 77.8798C105.277 78.7843 106.011 79.5175 106.915 79.5175Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M106.402 78.0194C106.439 78.0518 106.645 78.2252 106.949 78.2017C107.271 78.1767 107.453 77.9495 107.481 77.9131",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M101.396 85.0693H99.2927C99.13 85.0693 99.0142 85.2272 99.063 85.3824L99.8996 88.0392L101.396 85.0693Z",
    fill: "#0E171E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M127.404 119.751L134.056 118.453C134.056 118.453 135.532 118.244 136.653 118.385C138.268 118.587 144.271 120.908 144.525 121.638C144.603 121.863 144.582 122.083 144.582 122.083C144.537 122.544 144.17 122.847 144.056 122.941C143.654 123.273 142.934 123.379 141.345 122.986C140.475 122.771 139.271 122.388 137.906 121.665",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M137.814 125.993C138.121 125.995 138.815 125.95 139.25 125.469C139.905 124.744 139.788 123.23 138.646 122.032",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M136.709 126.748C136.895 126.688 137.438 126.484 137.739 125.942C138.133 125.232 137.819 124.47 137.693 124.165C137.178 122.916 135.857 122.503 135.62 122.434",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M133.828 127.154C133.487 127.034 132.896 126.881 132.188 126.995C131.748 127.065 130.963 127.191 130.752 127.747C130.631 128.068 130.732 128.451 130.916 128.708C131.412 129.396 132.591 129.274 133.258 129.205C134.131 129.114 135.362 128.986 136.128 127.952C136.264 127.769 136.933 126.866 136.63 125.81C136.362 124.879 135.441 124.183 134.306 124.079",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M131.71 126.107C131.461 126.52 130.95 127.245 130.047 127.839C129.034 128.504 128.155 128.66 127.666 128.704",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M127.722 128.686L129.377 128.211L127.405 119.75L127.722 128.686Z",
    fill: "#0E171E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2742 89.5255L63.7482 134.554C63.2353 135.425 63.8626 136.523 64.8732 136.524L100.919 136.548L101.198 132.967L121.623 132.585C122.943 132.561 123.985 131.453 123.928 130.133L123.395 117.747L102.253 119.429L104.088 95.8879C104.369 92.2836 102.188 88.9416 98.7761 87.7465L96.9165 87.0951C94.4061 86.2159 91.6243 87.2337 90.2742 89.5255Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4492 136.452L70.0336 140.042L70.3101 136.528L64.4492 136.452Z",
    fill: "#0E171E"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2314 119.843C99.7865 119.688 101.342 119.533 102.897 119.378",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4411 105.173L87.9774 120.771C86.961 127.206 91.9588 133.016 98.4735 132.974L102.102 132.95",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8191 132.857C96.8314 131.997 96.5477 130.509 95.7253 128.621C93.7475 124.08 88.592 123.925 87.8955 123.706",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M123.928 130.133C123.751 126.005 123.573 121.876 123.396 117.747C124.661 117.608 125.926 117.469 127.191 117.33C127.368 121.566 127.545 125.803 127.722 130.039C126.458 130.07 125.193 130.102 123.928 130.133Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M127.312 120.207C126.046 120.292 124.779 120.377 123.513 120.461",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M123.655 123.784C124.921 123.723 126.187 123.661 127.453 123.599",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M123.782 126.748C125.05 126.761 126.318 126.774 127.586 126.787",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSus);
export default __webpack_public_path__ + "static/media/sus.7b7b801aec14222d433de2a444576b3f.svg";
export { ForwardRef as ReactComponent };